import React from "react";
import { Box } from "@mantine/core";
import styles from "./WizardProgressBar.module.css";

interface WizardProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export default function WizardProgressBar({
  currentStep,
  totalSteps,
}: WizardProgressBarProps) {
  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <Box className={styles.progressBarContainer}>
      <Box className={styles.progressBar}>
        <Box
          className={styles.progressFill}
          style={{ width: `${progressPercentage}%` }}
        />
      </Box>
    </Box>
  );
}
